<template>
  <div class="edit-move-component">
    <modal
      ref="updateMoveInOutModal"
      modalId="editMoveModal"
      modalType="customize-modal"
      className="medium-modal"
      :showCloseBtn="false"
      :afterOpenModal="afterOpenModal"
    >
      <div slot="modal-header">
        <span class="modal-pure-text modal-pure-text--bigger modal-pure-text--label">
          {{ currentOption.addRecord }}
        </span>
      </div>
      <div
        slot="content"
        class="modal-content"
      >
        <div class="update-move-date input-row input-row--center row">
          <span
            class="modal-pure-text required-flag modal-pure-text--label"
          >
            {{ currentOption.actualDate }}
          </span>
          <DatePicker
            ref="datePicker"
            :required="true"
            :calendarButton="true"
            calendarButtonIcon="fa fa-calendar"
            :value="formatDate(requestParams.date)"
            @selected="val => updateDate(val)"
          />
        </div>
        <div class="update-bussiness-date input-row input-row--center row">
          <span
            class="modal-pure-text modal-pure-text--label"
          >
            {{ currentOption.businessDate }}
          </span>
          <DatePicker
            :calendarButton="true"
            calendarButtonIcon="fa fa-calendar"
            :value="formatDate(requestParams.businessDate)"
            @selected="val => updateBusinessDate(val)"
          />
        </div>
        <div class="input-row">
          <span class="modal-pure-text modal-pure-text--label">{{ $t('handover.moveInOut.header.remarks') }}</span>
          <TextField
            ref="remark-textfield"
            class="remark-textfield"
            :placeholder="$t('handover.moveInOut.message.moveInOutRemarkPlaceHolder',[currentOption.correspondingHotbs] )"
            :value="requestParams.remark"
            @updateValue="val => updateRemark(val)"
          />
        </div>
        <div class="update-hotbs input-row">
          <label class="modal-pure-text">{{ currentOption.correspondingHotbs }}</label>
          <HKLMultiSelect
            class="multi-value"
            :value="moveItemIds"
            :options="hotbHklOptions"
            placeholder=""
            @change="onHotbsChange"
          />
        </div>
        <div class="move-detail-table input-row">
          <CommonTable
            v-if="isActive"
            :needCache="false"
            :tableContentLists="tableContents"
            :renderHeaderList="tableHeader"
            :resizeColumnWhenContentChange="false"
            :defaultOrder="false"
            :needFilter="false"
            :tableId="tableId"
          />
        </div>
      </div>
      <div slot="btns">
        <button
          class="btn btn--darkblue"
          @click="close()"
        >{{ $t('action.cancel') }}</button>
        <button
          class="btn btn--orange"
          @click="openConfrimModal()"
        >{{ $t('action.saveAndNotify') }}</button>
      </div>
    </modal>

    <modal
      ref="saveConfirmModal"
      modalId="save-confirm-modal"
      :showCloseBtn="false"
    >
      <div slot="content">
        <div class="confirm-content">
          <span
            class="modal-pure-text"
          >
            {{ $t('handover.moveInOut.message.beforeSaving') }}
          </span>
        </div>
      </div>
      <div slot="btns">
        <button
          class="btn btn--darkblue"
          @click="closeConfrimModal()"
        >{{ $t('action.cancel') }}</button>
        <button
          class="btn btn--orange"
          @click="save()"
        >{{ $t('action.ok') }}</button>
      </div>
    </modal>
    <HKLModal
      ref="inputRequireModal"
      :zIndex="1005"
      :title="$t('handover.moveInOut.message.moveInOutInputHint',[currentOption.correspondingHotbs])"
      :hasCancelBtn="false"
    />
  </div>
</template>
<script>
import lodash from 'lodash'
import { mapGetters } from 'vuex'
import Modal from '@/controls/Modal'
import HKLMultiSelect from '@/controls/Select/HKLMultiSelect.vue'
import TextField from '@/controls/TextField'
import DatePicker from '@/controls/DatePicker'
import CommonTable from '@/controls/CommonTable'
import HKLModal from '@/controls/Modal/HKLModal'
import dateUtil from '@/utils/dateUtil'
import { utils as formUtils } from '@/plugin/InputChange'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { createMoveInOutAndNotify, updateMoveInOutAndNotify } from '@/api/tenancies/request'
import * as hotbApi from '@/api/hotb/request'
import { ccdRouteNames } from '@/utils/consts'
import { generateHotbDisplayName } from '@/modules/ccd/tenancy/utils'
import { getPublicLink } from '@/api/postman/util'
import { getFloorIndex } from '@/api/buildings/request'
import { hotbTypes } from '@/utils/locale'
import { MOVE_TYPE } from './const'
export default {
  components: {
    CommonTable,
    HKLMultiSelect,
    TextField,
    DatePicker,
    Modal,
    HKLModal,
  },
  data () {
    return {
      tableId: `move_detail`,
      isActive: false,
      currentOption: {},
      moveItems: [],
      tenancyId: this.$route.params.id,
      requestParams: {},
      originalMoveItems: [],
      hotbs: [],
    }
  },
  computed: {
    ...mapGetters('ccd', ['currentTenancy']),
    tableHeader () {
      return [
        {
          title: this.$t('handover.moveInOut.header.premises'),
          name: 'premises',
        },
        {
          title: this.$t('handover.moveInOut.header.floor'),
          name: 'floor',
          formatRule: this.formatFloors,
        },
        {
          title: this.$t('handover.moveInOut.header.date'),
          name: 'date',
          formatRule: this.formatDate,
        },
      ]
    },
    hotbList () {
      const newHotbList = this.hotbs.filter(hotb => hotb.type === this.currentOption.hotbType)
      if (newHotbList) {
        newHotbList.sort((a, b) => {
          return a.transactionDate > b.transactionDate ? -1 : 1
        })
        this.setDisplayName(newHotbList)
      }
      return newHotbList || []
    },
    hotbHklOptions () {
      return (this.hotbList || []).map((hotb) => ({
        name: hotb.displayName,
        value: hotb.id,
      }))
    },
    moveItemIds () {
      return (this.moveItems || []).map((item) => item.id)
    },
    tableContents () {
      return this.moveItems.map(hotb => {
        return {
          premises: hotb.premises,
          floor: hotb.floor,
          date: hotb.transactionDate,
        }
      })
    },
    moveOption () {
      return {
        [MOVE_TYPE.MOVE_IN]: {
          moveType: MOVE_TYPE.MOVE_IN,
          hotbType: hotbTypes.HANDOVER,
          addRecord: this.$t('handover.moveInOut.moveInPattern.addRecord'),
          actualDate: this.$t('handover.moveInOut.moveInPattern.actualDate'),
          correspondingHotbs: this.$t('handover.moveInOut.moveInPattern.correspondingHotbs'),
          businessDate: this.$t('handover.moveInOut.moveInPattern.businessDate'),
        },
        [MOVE_TYPE.MOVE_OUT]: {
          moveType: MOVE_TYPE.MOVE_OUT,
          hotbType: hotbTypes.TAKEBACK,
          addRecord: this.$t('handover.moveInOut.moveOutPattern.addRecord'),
          actualDate: this.$t('handover.moveInOut.moveOutPattern.actualDate'),
          correspondingHotbs: this.$t('handover.moveInOut.moveOutPattern.correspondingHotbs'),
          businessDate: this.$t('handover.moveInOut.moveOutPattern.businessDate'),
        },
      }
    },
  },
  methods: {
    formatDate (item) {
      return dateUtil.formatDate(item, false)
    },
    formatFloors (item) {
      return item.join(',')
    },
    onHotbsChange (ids) {
      const idList = Array.isArray(ids) ? ids : []
      this.moveItems = idList
        .map((id) => this.hotbList.find((hotb) => hotb.id === id))
        .filter(Boolean)
    },
    updateDate (val) {
      this.requestParams.date = val
    },
    updateBusinessDate (val) {
      this.requestParams.businessDate = val
    },
    updateRemark (val) {
      this.requestParams.remark = val
    },
    async save () {
      const emptyValue = this.$t('emptyValue')
      this.requestParams.type = this.currentOption.moveType
      let [addHotb, removeHotb] = this.compareMoveItems()
      this.requestParams.remark = this.requestParams.remark || ''
      this.requestParams.addHotb = addHotb
      this.requestParams.removeHotb = removeHotb

      const floors = []
      this.moveItems.forEach(item => {
        floors.push(...item.floor)
      })
      const uniqSortedFloors = lodash.orderBy(
        lodash.uniq(floors),
        floor => getFloorIndex(this.currentTenancy.building, floor),
      )
      this.requestParams.metaData = {
        date: dateUtil.formatDate(this.requestParams.date),
        businessDate: this.requestParams.businessDate ? dateUtil.formatDate(this.requestParams.businessDate) : emptyValue,
        remarks: this.requestParams.remark || emptyValue,
        floor: uniqSortedFloors.length !== 0 ? uniqSortedFloors.join(', ') : this.$t('emptyValue'),
        premises: this.moveItems.length !== 0 ? this.moveItems.map(item => item.premises).join(' || ') : this.$t('emptyValue'),
        tenancyId: this.currentTenancy.id,
        tradeName: lodash.get(this.currentTenancy, 'tradeName'),
        companyName: lodash.get(this.currentTenancy, 'company.name'),
        building: lodash.get(this.currentTenancy, 'building'),
        buildingFullName: lodash.get(this.currentTenancy, 'building.fullName'),
        subsidiary: this.$t('system.title'),
        type: lodash.get(this.currentTenancy, 'type'),
        linkToAccess: getPublicLink(ccdRouteNames.ccdTenancyView, this.currentTenancy.id),
      }
      if (this.requestParams.id) {
        await updateMoveInOutAndNotify(this.tenancyId, this.requestParams)
      } else {
        await createMoveInOutAndNotify(this.tenancyId, this.requestParams)
      }
      this.$emit('afterSave')
      this.closeConfrimModal()
    },
    compareMoveItems () {
      const addHotb = this.moveItems.filter(item =>
        !this.originalMoveItems.some(originalItem => item.id === originalItem.id)).map(item => item.id)
      const removeHotb = this.originalMoveItems.filter(originalItem =>
        !this.moveItems.some(item => item.id === originalItem.id)).map(item => item.id)
      return [addHotb, removeHotb]
    },
    setOption (optionName) {
      this.currentOption = this.moveOption[optionName]
    },
    open () {
      this.$refs.updateMoveInOutModal.open()
      this.isActive = true
    },
    close () {
      formUtils.resetDirty()
      this.$refs.updateMoveInOutModal.close()
    },
    openConfrimModal () {
      if (!this.validate()) {
        return
      }
      if (this.moveItems.length || this.requestParams.remark) {
        this.$refs.saveConfirmModal.open()
      } else {
        this.$refs.inputRequireModal.open()
      }
    },
    closeConfrimModal () {
      this.$refs.saveConfirmModal.close()
      this.close()
    },
    setMoveInOutParams (item) {
      this.requestParams.id = item.id
      this.requestParams.date = item.date
      this.requestParams.businessDate = item.businessDate
      this.requestParams.remark = item.remark
      const getHotbs = lodash.cloneDeep(item.hotbs)
      this.setDisplayName(getHotbs)
      this.moveItems = getHotbs
      this.originalMoveItems = lodash.cloneDeep(item.hotbs)
    },
    validate () {
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '.update-move-date')
      return fusionInputCheckUtil.isAllFieldsValid('.update-move-date')
    },
    async initMoveInOut () {
      this.$set(this.requestParams, 'id', '')
      this.$set(this.requestParams, 'remark', '')
      this.$set(this.requestParams, 'date', '')
      this.$set(this.requestParams, 'businessDate', '')
      this.currentOption = {}
      this.isActive = false
      this.moveItems = []
      this.originalMoveItems = []
      await this.loadHotbs()
    },
    setDisplayName (hotb) {
      if (hotb && Array.isArray(hotb)) {
        hotb.forEach(hotb => {
          hotb.displayName = generateHotbDisplayName(this.currentTenancy, hotb)
        })
      }
    },
    async loadHotbs () {
      const tempHotbs = await hotbApi.listAll({
        hotb: {
          status: ['APPR', 'SCHEDULED', 'UNSIGNED', 'COMPLETED'],
          tenancyId: this.tenancyId,
        },
      }) || []
      this.hotbs = tempHotbs
    },
    afterOpenModal () {
      this.$refs['remark-textfield'].$forceUpdate()
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~styles/popup';
.modal-pure-text--bigger {
  font-size: 16px
}
.modal-pure-text--label{
  margin-bottom: 0px;
  margin-right: 12px;
}
.modal-content {
  margin-left: 12px;
  padding-right: 12px;
  .input-row {
    padding-top: 12px;
  }
  .input-row--center {
    align-items: center;
  }
}
.remark-textfield {
  & ::v-deep textarea {
    width: 100%;
  }
}
.update-hotbs {
  & ::v-deep .hkl-select {
    width: 600px;
  }
}
.move-detail-table {
  min-height: 180px;
  & ::v-deep .table-list {
    width: 100%;
  }
  & ::v-deep .common-table-header-container {
    min-width: 100% !important;
    max-width: 100% !important;
  }
  & ::v-deep .common-table-content-container {
    min-width: 100% !important;
    max-width: 100% !important;
  }
  & ::v-deep .common-table {
    min-width: 100% !important;
    max-width: 100% !important;
    min-height: unset;
    margin: 0;
    .floor, .date {
      width: 25%;
    }
    .premises {
      width: 50%;
    }
  }
}

#editMoveModal {
  display:inline-flex;
  & ::v-deep .customize-modal {
    width: 75vw;
    max-width: 1080px;
  }
}
</style>
